import { ConfigPatch } from 'src/config/types';

export default (): ConfigPatch => ({
    salesChannelId: '07e4c8f3-ba6e-437c-8741-f0e74fd9df42',
    countryCodes: ['PT'],
    locale: 'pt-PT',
    enable: {
        prelaunch: true,
    },
});
